import { Button, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import { capitalize } from "lodash";
import { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import EyeIcon from "../../../assets/icons/EyeIcon";
import LeftArrowIcon from "../../../assets/icons/LeftArrowIcon";
import { addKeyInArray } from "../../../helpers/siteConfig";
import useDebounce from "../../../hooks/useDebounce";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import { getSingleTowerlogAsync } from "../../../store/features/NP/network/networkAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { SingleTowerLog, TableData } from "../../../types/redux";
import { stringToArray } from "../../../utils/array";
import CustomTable from "../../common/CustomTable";
import IconButton from "../../common/IconButton";
import Subheader from "../../ui/Subheader";
import ViewLog from "./ViewLog";

export default function SingleNetworkTable() {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const path = stringToArray(location.pathname, "/")?.[0];
  const { id } = useParams() as { id: string };
  const { loading, SingleTowerLog } = useAppSelector(
    (state) => state.SingleTowerLog
  );

  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<string>(
    (searchParams.get("status") as string)
      ? (searchParams.get("status") as string)
      : (searchParams.get("pg") as string)
      ? `pg-${searchParams.get("pg")}`
      : ""
  );

  const { open, toggle, handleOpen } = useModal();
  const {
    open: confirmOpen,
    toggle: confirmToggle,
    handleOpen: handleConfirmOpen,
  } = useModal();
  const { handleSetFirstPage, handlePagination, ...rest } = useTable();
  // const { towersCount, allTowers } = useAppSelector(
  //   (state) => state.network
  // );
  const { keyword, handleInputChange, handleEnterValue } = useDebounce();
  const {
    keyword: siteCode,
    handleInputChange: handleInputChange2,
    handleEnterValue: handleEnterValue2,
  } = useDebounce();

  const handleSiteLocator = (value: string) => {
    setStatus(value);
    handleSetFirstPage(true);
  };

  useEffect(() => {
    dispatch(
      getSingleTowerlogAsync({
        params: { id: id },
      })
    );
  }, [dispatch, id]);

  const dataList =
    SingleTowerLog && Array.isArray(SingleTowerLog)
      ? addKeyInArray(SingleTowerLog)
      : [];

  // useEffect(() => {
  //   console.log(SingleTowerLog);
  // }, [SingleTowerLog]);

  const FormatDate = (date: string) => {
    if (!date) return "N/A"; // Handle null/undefined cases

    // Split the "20/02/2025" format into day, month, and year
    const [day, month, year] = date.split("/");

    // Ensure the date is properly formatted
    const parsedDate = new Date(`${year}-${month}-${day}`);

    if (isNaN(parsedDate.getTime())) {
      return "N/A"; // Handle invalid date formats
    }

    // Format with a comma after the month
    return parsedDate
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
      .replace(/ (\w+) /, " $1, ");
  };

  const columns: ColumnsType<TableData<SingleTowerLog>> = [
    {
      title: "Date",
      render: (val: SingleTowerLog) =>
        val?.date ? FormatDate(val.date) : "N/A",
    },
    {
      title: "TT Number",
      dataIndex: "ticketNumber",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: "Status",
      render: (val: SingleTowerLog) => (
        <span
          className={`status ${
            val?.status === "pending"
              ? "status-pending"
              : val?.status === "reached"
              ? "status-waiting"
              : val?.status === "finished"
              ? "status-done"
              : val?.status === "start"
              ? "status-info"
              : null
          }`}
        >
          {capitalize(val?.status) || "N/A"}
        </span>
      ),
    },
    {
      title: "Action",
      align: "center",
      render: (val: SingleTowerLog) => (
        <Button
          icon={<EyeIcon />}
          onClick={() =>
            handleOpen({
              type: "LOG",
              data: val,
            })
          }
          disabled={!val?._id ? true : false}
        />
      ),
    },
  ];

  const isVendor = false;

  return (
    <>
      {/* <AdminLayout title="Networks" headerTitle="Networks">
    
      </AdminLayout> */}

      <section className="mt-7">
        <Subheader title="TT List">
          <Space size="middle" className="flex-wrap">
            <Link to={`/${path}/networks`}>
              <IconButton
                className="!border-others-header !text-sm !font-normal !rounded-lg !border !text-header !bg-transparent"
                type="default"
                icon={<LeftArrowIcon />}
              >
                <span>Back</span>
              </IconButton>
            </Link>
          </Space>
        </Subheader>
      </section>

      {open.type === "LOG" && (
        <ViewLog
          title="Site Locator Log"
          locatorTitle=""
          open={open.open}
          data={open?.data}
          handleClose={toggle}
          type="SINGLE_LIST"
        />
      )}

      <CustomTable<TableData<SingleTowerLog>>
        loading={loading}
        total={10}
        page={10}
        handlePagination={handlePagination}
        columns={isVendor ? columns?.slice(0, columns?.length - 2) : columns}
        dataList={dataList}
        isPagination={keyword ? false : true}
      />
    </>
  );
}
